import type { OrderEdit } from '@medusajs/medusa'

interface CustomerBalanceOrderParams {
  paid_total: number
  refunded_total: number
  shipping_total: number
  total: number
}

export class LiveOrderBalanceService {
  /**
   * The customer balance for an order is the difference between total paid and sum of the total order and total refunded
   * A negative balance means the customer must pay more.
   * A positive balance means the customer must be refunded.
   *
   * @param order
   * @returns customer balance for this order
   */
  public getCustomerBalance(
    order: CustomerBalanceOrderParams | undefined,
    orderEdits: OrderEdit[] | undefined
  ): number {
    if (!order) {
      return 0
    }

    const requestedOrderEditDifferenceDue =
      orderEdits?.find(
        (orderEdit) =>
          orderEdit.status === 'requested' || orderEdit.status === 'created'
      )?.difference_due ?? 0

    const requestedOrderEditAwaitingPayment = Math.max(
      0,
      requestedOrderEditDifferenceDue
    )

    return (
      order.paid_total -
      order.refunded_total -
      order.total -
      requestedOrderEditAwaitingPayment
    )
  }
}
